import React from 'react'
import { FormattedMessage } from 'react-intl'

// @ts-expect-error — importing a non declares js file
import { getLibrary } from '@23/web-components/dist/collection/components/0_components/icon-library/icon-library-registry'

import { useWebinarColors } from '../../../sharedLegacy/hooks/useWebinarColors'
import {
  WebinarPanelComponent,
  WebinarSidebarSeparator,
} from '../../../sharedLegacy/features/WebinarSidebarFeature/components'
import ButtonComponent from '../../../sharedLegacy/components/ButtonComponent/ButtonComponent'

import './JoinToSpeakInfoPanel.scss'

type Props = {
  onDismiss: () => void
  onAccept: () => void
}

const JoinToSpeakInfoPanel = ({ onDismiss, onAccept }: Props) => {
  const webinarColors = useWebinarColors()

  return (
    <>
      <WebinarPanelComponent className="join-to-speak-info-panel">
        <ul
          style={{
            '--check-icon-url': `url(${getLibrary('one').resolver('check')})`,
          }}
        >
          <li>
            <FormattedMessage defaultMessage="Ask questions and chat with the speakers live on video." />
          </li>
          <li>
            <FormattedMessage defaultMessage="In the next step, give your browser access to your camera and microphone." />
          </li>
          <li>
            <FormattedMessage defaultMessage="You can then request access to get on camera." />
          </li>
        </ul>

        <div className="buttons">
          <ButtonComponent
            className="cancel-button"
            type="button"
            color="themed"
            style={{
              backgroundColor: webinarColors.tabs.contrast.transparent('5%'),
              color: webinarColors.tabs.contrast.color,
            }}
            round
            ariaLabel=""
            onClick={onDismiss}
          >
            <FormattedMessage defaultMessage="Cancel" />
          </ButtonComponent>
          <ButtonComponent
            className="accept-button"
            type="button"
            color="themed"
            style={{
              backgroundColor: webinarColors.accent.color,
              color: webinarColors.accent.contrast.color,
            }}
            round
            ariaLabel=""
            onClick={onAccept}
          >
            <FormattedMessage defaultMessage="Give permissions" />
          </ButtonComponent>
        </div>
      </WebinarPanelComponent>
      <WebinarSidebarSeparator />
    </>
  )
}

export default JoinToSpeakInfoPanel
